export default __webpack_public_path__ + "static/media/english-to-russian-screenshot-01.3bb27c68.png";